var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_43016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.415 38.1421H63.1338V46.2671H66.415V38.1421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9775 38.1421H69.6963V46.2671H72.9775V38.1421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.415 49.5171H63.1338V52.7671H66.415V49.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9775 49.5171H69.6963V52.7671H72.9775V49.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9307 56.0171H51.6494V59.2671H54.9307V56.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7275 88.5171H43.4463V91.7671H46.7275V88.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9775 56.0171H69.6963V59.2671H72.9775V56.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.415 62.5171H63.1338V65.7671H66.415V62.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9775 62.5171H69.6963V65.7671H72.9775V62.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07129 4.01709H8.99316V0.76709H2.43066C1.52504 0.76709 0.790039 1.49509 0.790039 2.39209V8.89209H4.07129V4.01709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.149 0.76709H97.5869V4.01709H102.509V8.89209H105.79V2.39209C105.79 1.49509 105.055 0.76709 104.149 0.76709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07129 96.6421H0.790039V103.142C0.790039 104.039 1.52504 104.767 2.43066 104.767H8.99316V101.517H4.07129V96.6421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.509 101.517H97.5869V104.767H104.149C105.055 104.767 105.79 104.039 105.79 103.142V96.6421H102.509V101.517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35254 8.89209V28.3921C7.35254 29.2891 8.08754 30.0171 8.99316 30.0171H28.6807C29.5863 30.0171 30.3213 29.2891 30.3213 28.3921V8.89209C30.3213 7.99509 29.5863 7.26709 28.6807 7.26709H8.99316C8.08754 7.26709 7.35254 7.99509 7.35254 8.89209ZM10.6338 10.5171H27.04V26.7671H10.6338V10.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1182 13.7671H15.5557C14.65 13.7671 13.915 14.4951 13.915 15.3921V21.8921C13.915 22.7891 14.65 23.5171 15.5557 23.5171H22.1182C23.0238 23.5171 23.7588 22.7891 23.7588 21.8921V15.3921C23.7588 14.4951 23.0238 13.7671 22.1182 13.7671ZM20.4775 20.2671H17.1963V17.0171H20.4775V20.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8994 30.0171H97.5869C98.4925 30.0171 99.2275 29.2891 99.2275 28.3921V8.89209C99.2275 7.99509 98.4925 7.26709 97.5869 7.26709H77.8994C76.9938 7.26709 76.2588 7.99509 76.2588 8.89209V28.3921C76.2588 29.2891 76.9938 30.0171 77.8994 30.0171ZM79.54 10.5171H95.9463V26.7671H79.54V10.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0244 13.7671H84.4619C83.5563 13.7671 82.8213 14.4951 82.8213 15.3921V21.8921C82.8213 22.7891 83.5563 23.5171 84.4619 23.5171H91.0244C91.93 23.5171 92.665 22.7891 92.665 21.8921V15.3921C92.665 14.4951 91.93 13.7671 91.0244 13.7671ZM89.3838 20.2671H86.1025V17.0171H89.3838V20.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6807 75.5171H8.99316C8.08754 75.5171 7.35254 76.2451 7.35254 77.1421V96.6421C7.35254 97.5391 8.08754 98.2671 8.99316 98.2671H28.6807C29.5863 98.2671 30.3213 97.5391 30.3213 96.6421V77.1421C30.3213 76.2451 29.5863 75.5171 28.6807 75.5171ZM27.04 95.0171H10.6338V78.7671H27.04V95.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5557 91.7671H22.1182C23.0238 91.7671 23.7588 91.0391 23.7588 90.1421V83.6421C23.7588 82.7451 23.0238 82.0171 22.1182 82.0171H15.5557C14.65 82.0171 13.915 82.7451 13.915 83.6421V90.1421C13.915 91.0391 14.65 91.7671 15.5557 91.7671ZM17.1963 85.2671H20.4775V88.5171H17.1963V85.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9775 31.6421H61.4932V12.1421H58.2119V33.2671C58.2119 34.1641 58.9469 34.8921 59.8525 34.8921H72.9775V31.6421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3682 20.2671H36.8838V23.5171H48.3682V20.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9307 13.7671H43.4463V17.0171H54.9307V13.7671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6338 31.6421H7.35254V46.2671H10.6338V31.6421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3213 41.3921H13.915V44.6421H28.6807V51.1421H31.9619V43.0171C31.9619 42.1201 31.2269 41.3921 30.3213 41.3921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8369 33.2671H15.5557V36.5171H18.8369V33.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5244 30.0171H35.2432V43.0171H38.5244V30.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0088 46.2671H35.2432V49.5171H50.0088V46.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.868 47.8921H97.5869V64.1421H92.665V67.3921H99.2275C100.133 67.3921 100.868 66.6641 100.868 65.7671V47.8921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7275 30.0171H43.4463V33.2671H46.7275V30.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6338 54.3921H7.35254V67.3921H10.6338V54.3921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1182 69.0171H7.35254V72.2671H22.1182V69.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8213 46.2671H86.1025V39.7671C86.1025 38.8701 85.3675 38.1421 84.4619 38.1421H76.2588V41.3921H82.8213V46.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8369 54.3921H15.5557V57.6421H18.8369V54.3921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8838 52.7671H33.6025V65.7671H36.8838V52.7671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3682 69.0171H33.6025V72.2671H48.3682V69.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6807 62.5171H13.915V65.7671H28.6807V62.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5244 85.2671H35.2432V91.7671H38.5244V85.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3682 78.7671H33.6025V82.0171H48.3682V78.7671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8525 72.2671V64.1421C59.8525 63.2451 59.1175 62.5171 58.2119 62.5171H41.8057V65.7671H56.5713V72.2671H59.8525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7275 52.7671H43.4463V56.0171H46.7275V52.7671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6807 56.0171H25.3994V59.2671H28.6807V56.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.868 86.8921H97.5869V98.2671H100.868V86.8921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3057 95.0171H89.3838V98.2671H94.3057V95.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.665 85.2671H89.3838V91.7671H92.665V85.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.868 72.2671C100.868 71.3701 100.133 70.6421 99.2275 70.6421H81.1807V73.8921H97.5869V83.6421H100.868V72.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.54 91.7671V83.6421C79.54 82.7451 78.805 82.0171 77.8994 82.0171H59.8525V85.2671H76.2588V91.7671H79.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3057 77.1421H82.8213V80.3921H94.3057V77.1421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0869 95.0171H33.6025V98.2671H45.0869V95.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.29 83.6421H50.0088V98.2671H53.29V83.6421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8525 75.5171H53.29V78.7671H59.8525V75.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8994 59.2671H86.1025V56.0171H79.54V46.2671H76.2588V57.6421C76.2588 58.5391 76.9938 59.2671 77.8994 59.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0244 49.5171H82.8213V52.7671H91.0244V49.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3057 33.2671H89.3838V36.5171H94.3057V33.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.868 33.2671H97.5869V41.3921H100.868V33.2671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.665 41.3921H89.3838V44.6421H92.665V41.3921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7744 28.3921H71.3369C72.2425 28.3921 72.9775 27.6641 72.9775 26.7671V5.64209H69.6963V25.1421H64.7744V28.3921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.165 8.89209H64.7744V5.64209H38.5244C37.6188 5.64209 36.8838 6.37009 36.8838 7.26709V15.3921H40.165V8.89209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8057 39.7671H53.29C54.1957 39.7671 54.9307 39.0391 54.9307 38.1421V25.1421H51.6494V36.5171H41.8057V39.7671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8525 38.1421H56.5713V44.6421H59.8525V38.1421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3369 88.5171H59.8525V91.7671H71.3369V88.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6182 95.0171H59.8525V98.2671H74.6182V95.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8213 95.0171H79.54V98.2671H84.4619C85.3675 98.2671 86.1025 97.5391 86.1025 96.6421V83.6421H82.8213V95.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3213 69.0171H27.04V72.2671H30.3213V69.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3369 69.0171H64.7744V72.2671H71.3369V69.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.54 62.5171H76.2588V67.3921H79.54V62.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8994 70.6421H74.6182V73.8921H77.8994V70.6421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6963 75.5171H64.7744V78.7671H69.6963V75.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1025 62.5171H82.8213V65.7671H86.1025V62.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3057 56.0171H89.3838V59.2671H94.3057V56.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.415 56.0171H58.2119V59.2671H66.415V56.0171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8525 47.8921H56.5713V52.7671H59.8525V47.8921Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_43016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 104,
    fill: "white",
    transform: "translate(0.790039 0.76709)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.83a2f7865f09bb11d18009c5ed3c5d40.svg";
export { ForwardRef as ReactComponent };